import Icon from '@ant-design/icons';
import { updateSector } from '@api/announcement';
// import { userInfo } from '@store';
import { Col, Form, Row } from 'antd';
import { useState } from 'react';
// import { useRecoilState } from 'recoil';
import { useAccountPopup } from '../AccountPopup';
import { CURRENCY, editIcon, use_ANNOUNCEMENTINFORMATION } from './data';
import { EditInfoModal } from './editInfoModal';
import './index.scss';
export const useBaseInfo = ({
  details = {},
  dict,
  getAnnInfo,
  isFinishAction,
  isReturnAction,
  systemCity,
  checkNeedOperation
}: any) => {
  const [open, setOpen] = useState(false);
  const [isInfoMadalOpen, setIsInfoMadalOpen] = useState(false);
  const handleCancel = () => {
    setOpen(false);
  };
  const { accountComponent } = useAccountPopup({ handleCancel, open, details });
  const [form] = Form.useForm();
  // const [userInfos] = useRecoilState(userInfo);

  const ANNOUNCEMENTINFORMATION = use_ANNOUNCEMENTINFORMATION();

  const handleDisplayAccount = () => {
    setOpen(true);
  };

  const baseInfoItemRender = (x: any) => {
    if (x.render) {
      return x.render(details);
    }
    if (x.montage) {
      return `${details[x.key] || ''} ${
        x.needConversion
          ? (details[x.key] && CURRENCY[details[x.montage] - 1]) || ''
          : details[x.montage] || ''
      }`;
    }

    return details[x.key] || '';
  };

  const formatItemArr = (data: typeof ANNOUNCEMENTINFORMATION) => {
    return data.map((x: any) => {
      if (x.key === 'sectorTypeValue') {
        x.render = (record: any) => {
          const { sectorTypeValue } = record;
          return (
            <div>
              {sectorTypeValue}
              {!isFinishAction && !isReturnAction && (
                <Icon
                  component={() => editIcon}
                  style={{
                    marginLeft: 4,
                    cursor: 'pointer'
                  }}
                  onClick={onInfoEditClick}
                />
              )}
            </div>
          );
        };
      }
      return x;
    });
  };

  const onInfoEditClick = async () => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;

    setIsInfoMadalOpen(true);
  };
  const handleOk = async (data: any) => {
    setIsInfoMadalOpen(false);
    await updateSector({
      noticeCode: details.noticeCode,
      ...data
    });
    await getAnnInfo?.();
  };

  const baseInfoComponent = (
    <>
      <Row gutter={[18, 18]}>
        <Col span={24} className="pc-info-flex">
          {/* { label: '信息标题', value: '', key: 'infoTitle' } */}
          <div className="pc-info-label">信息标题 :</div>
          <div className="pc-info-value">{details.infoTitle}</div>
        </Col>
        {formatItemArr(ANNOUNCEMENTINFORMATION).map((x: any, index: number) => {
          return (
            <Col span={8} key={index} className="pc-info-flex">
              <div className="pc-info-label">{x.label} :</div>
              <div className="pc-info-value">{baseInfoItemRender(x)}</div>
            </Col>
          );
        })}
        <Col span={24} className="pc-info-flex">
          <div className="pc-info-label">公告链接 :</div>
          <div>
            <a
              href={details.noticeLink}
              target="_blank"
              className="pc-info-link"
            >
              Link{' '}
            </a>
            &nbsp;
            <span className="pc-info-password" onClick={handleDisplayAccount}>
              查看千里马账号密码
            </span>
          </div>
        </Col>
      </Row>
      {accountComponent}
      <EditInfoModal
        formRef={form}
        record={details}
        handleOk={handleOk}
        open={isInfoMadalOpen}
        setOpen={setIsInfoMadalOpen}
        dicList={dict}
        systemCity={systemCity}
      />
    </>
  );
  return {
    baseInfoComponent
  };
};
